import css from "./Card.module.scss";
import SwiperBlock from "../swiperblock/SwiperBlock";

const Card = ({ title, images, children, label }) => {
    return (
        <div className={css.root}>
            <div className={css.cardInner}>
                { images && <div className={css.cardImages}>
                     <SwiperBlock>{images}</SwiperBlock>
                </div> }
                <div className={css.cardTexts}>
                    { title && <h4>{title}</h4> }
                    { children && children }
                    { label && <div className={css.label}>{label}</div> }
                </div>
            </div>
        </div>
    )
}

export default Card;